// src/app/(dashboard)/meter/utils/meterStatus.ts
import { computeMeterStatus } from "@/lib/meterStatus";

export type { MeterOnlineStatus as MeterStatus } from "@/lib/meterStatus";

// Accepting `now` means the caller controls the clock.
// This makes the functions pure, testable, and reactive to the ticker.

// Delegates to the shared computeMeterStatus so the UI's displayed status
// always agrees with the query layer's sort/filter (lib/db/queries/meters.ts).
export const getMeterStatus = computeMeterStatus;

export function getRelativeTime(
  dateStr: string | null,
  now: number = Date.now(),
): string {
  if (!dateStr) return "ไม่เคย";
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    const diffMs = now - date.getTime();
    const diffMinutes = Math.floor(diffMs / 60_000);
    if (diffMinutes < 1) return "เมื่อสักครู่";
    if (diffMinutes < 60) return `${diffMinutes} นาทีที่แล้ว`;
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} ชม. ที่แล้ว`;
    return `${Math.floor(diffHours / 24)} วันที่แล้ว`;
  } catch {
    return dateStr;
  }
}

export function formatReadableTime(dateStr: string | null): string {
  if (!dateStr) return "-";
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toLocaleTimeString("th-TH", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  } catch {
    return dateStr;
  }
}
